import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { landingSlugForRole } from '../config/menuData.js';

/**
 * Role boundary for authenticated routes. Use INSIDE <ProtectedRoute> to wall
 * audiences off from each other:
 *
 *   <Route element={<RoleRoute allow={['Buyer']} />}>   // customers only
 *   <Route element={<RoleRoute deny={['Buyer']} />}>    // internal staff only
 *
 * A disallowed user is redirected to their own role landing (never shown the
 * page), so an external customer can't reach the internal operations shell and
 * vice-versa — even by typing the URL or via a stale post-login redirect.
 */
export default function RoleRoute({ allow, deny }) {
  const { user } = useAuth();
  const role = user?.role;

  const permitted = allow
    ? allow.includes(role)
    : deny
      ? !deny.includes(role)
      : true;

  if (!permitted) {
    return <Navigate to={`/${landingSlugForRole(role)}`} replace />;
  }

  return <Outlet />;
}
